import { isElementInViewport } from '@theme/utilities';

class StickyAddToCart extends HTMLElement {
  constructor() {
    super();

    this.form = null;
    this.footer = null;

    // 1. On "bind" la fonction une seule fois en mémoire pour pouvoir l'ajouter et la retirer proprement
    this.handleScroll = this.#displayStickyAddToCart.bind(this);
  }

  connectedCallback() {
    this.form = this.closest('[data-ref="product-form"]');
    this.footer = document.querySelector('[data-ref="footer"]');

    this.#displayStickyAddToCart();

    // 2. On utilise la référence stockée
    window.addEventListener('scroll', this.handleScroll);
    
    // Bonus : Écouter le redimensionnement permet de désactiver/activer le sticky en direct 
    // si l'utilisateur tourne son appareil ou redimensionne sa fenêtre.
    window.addEventListener('resize', this.handleScroll);
  }

  disconnectedCallback() {
    // 3. Le removeEventListener va maintenant fonctionner parfaitement
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleScroll);
  }

  #displayStickyAddToCart() {
    // 4. On ajoute la condition pour les écrans de 750px et plus
    if (window.matchMedia('(min-width: 750px)').matches) {
      // Sur Desktop : On force la désactivation de la barre et on arrête la fonction (return)
      this.dataset.active = 'false';
      this.classList.remove('color-scheme-1');
      return; 
    }

    // 5. Reste de ta logique d'origine, qui ne s'exécutera que sur mobile (< 750px)
    if (isElementInViewport(this.form) || isElementInViewport(this.footer)) {
      this.dataset.active = 'false';
      this.classList.remove('color-scheme-1');
    } else {
      this.dataset.active = 'true';
      this.classList.add('color-scheme-1');
    }
  }
}

if (!customElements.get('sticky-add-to-cart')) {
  customElements.define('sticky-add-to-cart', StickyAddToCart);
}